import { JobJustification } from "@/types/hiring-justification.types";
import React from "react";

type JobJustificationStatusProps = {
	data: JobJustification;
};

const JobJustificationStatus: React.FC<JobJustificationStatusProps> = ({
	data,
}) => {
	if (data.cfo_approved) {
		return (
			<div className="py-1 px-3 bg-green-200 rounded-lg">
				<p className="text-green-600 text-sm">CFO Approved</p>
			</div>
		);
	}

	if (data.cfo_rejected) {
		return (
			<div className="py-1 px-3 bg-red-200 rounded-lg">
				<p className="text-red-600 text-sm">CFO Disapproved</p>
			</div>
		);
	}

	if (!data.cfo_approved && !data.cfo_rejected) {
		return (
			<div className="py-1 px-3 bg-purple-200 rounded-lg">
				<p className="text-purple-600 text-sm">Awaiting CFO Approval</p>
			</div>
		);
	}
	if (data.hr_manager_approved) {
		return (
			<div className="py-1 px-3 bg-green-200 rounded-lg">
				<p className="text-green-600 text-sm">HR Manager Approved</p>
			</div>
		);
	}

	if (data.hr_manager_rejected) {
		return (
			<div className="py-1 px-3 bg-red-200 rounded-lg">
				<p className="text-red-600 text-sm">HR Manager Disapproved</p>
			</div>
		);
	}

	if (!data.hr_manager_approved && !data.hr_manager_rejected) {
		return (
			<div className="py-1 px-3 bg-purple-200 rounded-lg">
				<p className="text-purple-600 text-sm">Awaiting HR Manager Approval</p>
			</div>
		);
	}

	if (data.hr_partner_approved) {
		return (
			<div className="py-1 px-3 bg-green-200 rounded-lg">
				<p className="text-green-600 text-sm">HR Partner Approved</p>
			</div>
		);
	}

	if (data.hr_partner_rejected) {
		return (
			<div className="py-1 px-3 bg-red-200 rounded-lg">
				<p className="text-red-600 text-sm">HR Partner Disapproved</p>
			</div>
		);
	}

	if (!data.hr_partner_approved && !data.hr_partner_rejected) {
		return (
			<div className="py-1 px-3 bg-purple-200 rounded-lg">
				<p className="text-purple-600 text-sm">Awaiting HR Partner Approval</p>
			</div>
		);
	}

	if (data.finance_partner_approved) {
		return (
			<div className="py-1 px-3 bg-green-200 rounded-lg">
				<p className="text-green-600 text-sm">Finance Partner Approved</p>
			</div>
		);
	}

	if (data.finance_partner_rejected) {
		return (
			<div className="py-1 px-3 bg-red-200 rounded-lg">
				<p className="text-red-600 text-sm">Finance Partner Disapproved</p>
			</div>
		);
	}

	return (
		<div className="py-1 px-3 bg-purple-200 rounded-lg">
			<p className="text-purple-600 text-sm">Awaiting Finance Partner Approval</p>
		</div>
	);
};

export default JobJustificationStatus;
